import ActivityLogic from '../../logic/ActivityLogic'
import { nextUnseenCheckpointVideo } from '../../logic/checkpointVideo'
import { useFullscreenAnnouncement } from '../../hooks/announcements/useFullscreenAnnouncement'
import { useActivityLogs } from '../../hooks/activity/useActivityLogs'
import { useChallengeContext } from '../../hooks/challenge/useChallengeContext'
import { useCheckpoints } from '../../hooks/checkpoint/useCheckpoints'
import {
  useRecordEngagement,
  useUserEngagements,
} from '../../hooks/engagement/useUserEngagements'
import { useGates } from '../../hooks/gate/useGates'
import FullscreenVideoOverlay from '../../ui/primitives/FullscreenVideoOverlay'

type VideoDecision = 'pending' | 'show' | 'hide'

export default function CheckpointVideo() {
  const announcement = useFullscreenAnnouncement()
  const { data: checkpoints } = useCheckpoints()
  const { data: gates } = useGates()
  const { data: activityLogs } = useActivityLogs()
  const { data: challengeContext } = useChallengeContext()
  const engagements = useUserEngagements()
  const { mutate: recordEngagement } = useRecordEngagement()

  const seenCheckpointIds = new Set(
    (engagements.data ?? [])
      .filter((engagement) => engagement.subjectType === 'checkpoint')
      .map((engagement) => engagement.subjectID),
  )
  const next =
    checkpoints && gates && activityLogs && challengeContext
      ? nextUnseenCheckpointVideo(
          checkpoints,
          new Set(gates.map((gate) => gate.checkpointID)),
          ActivityLogic.getTotalProgress(activityLogs),
          seenCheckpointIds,
          challengeContext.goal,
          challengeContext.challenge.finishLineVideoUrl,
        )
      : undefined

  let decision: VideoDecision = 'pending'
  if (
    !announcement.pending &&
    engagements.isSuccess &&
    checkpoints &&
    gates &&
    activityLogs &&
    challengeContext
  ) {
    decision = !announcement.active && next?.videoUrl ? 'show' : 'hide'
  }

  return (
    <>
      <span data-testid="checkpoint-video-state" data-state={decision} hidden />
      {decision === 'show' && next?.videoUrl && (
        <FullscreenVideoOverlay
          testId="checkpoint-video"
          videoUrl={next.videoUrl}
          dismissible
          onClose={() => recordEngagement({ subjectType: 'checkpoint', subjectID: next.id })}
        />
      )}
    </>
  )
}
